import {
  Location as LocationDto,
  SiteWithAddress as SiteWithAddressDto,
} from '@electricjs/core_entity-client';

export const mockOrganizationId = 'e4f38e02-7f1a-4c0d-8f42-6b6c6c9a1a3e';

export const mockHqWarehouseSite: SiteWithAddressDto = {
  id: '9e6a0f9e-6b1a-4c8b-9a3a-3a2f6b0f9e6a',
  name: 'HQ Warehouse',
  phone_number: '2125551234',
  organization_id: mockOrganizationId,
  is_archivable: true,
  address: {
    street_1: '500 Warehouse Way',
    street_2: '',
    city: 'Newark',
    state: 'NJ',
    zip_code: '07102',
    country: 'US',
  },
};

export const mockOfficeSite: SiteWithAddressDto = {
  id: '3b7d1c52-0f64-4a52-9a8e-2f1d6e5b7c10',
  name: 'New York Office',
  phone_number: '2125554321',
  organization_id: mockOrganizationId,
  is_archivable: true,
  address: {
    street_1: '123 Main St',
    street_2: 'Floor 4',
    city: 'New York',
    state: 'NY',
    zip_code: '10001',
    country: 'US',
  },
};

export const mockSites: SiteWithAddressDto[] = [
  mockHqWarehouseSite,
  mockOfficeSite,
];

export const mockLocations: LocationDto[] = [
  {
    id: 'c1a5d8e4-7b3f-4e21-8d6a-9f0b2c3d4e51',
    site_id: mockOfficeSite.id,
    name: 'Server Room',
  },
  {
    id: 'd2b6e9f5-8c4a-4f32-9e7b-0a1c3d4e5f62',
    site_id: mockOfficeSite.id,
    name: 'IT Closet',
  },
  {
    id: 'e3c7fa06-9d5b-4a43-8f8c-1b2d4e5f6a73',
    site_id: mockHqWarehouseSite.id,
    name: 'Aisle 1',
  },
];
